exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card>.card-header h2[data-v-6af73cff],.card>.card-header h5[data-v-6af73cff]{margin:0}@media(max-width:680px){.card-login[data-v-6af73cff]{width:90%;margin:0 auto}}@media(max-width:576px){.card-login[data-v-6af73cff]{width:100%;margin:0 auto}}", ""]);

// exports
